import { createConfigs, FoundOccurrence, searchMutableObject } from '@features/flowSearch'
import { PromptAnswerSchema, QuestionAnswerSchema, QuestionStepSchema } from '@feedyou/schema'

import { Search } from '../../../types'

export const search: Search<QuestionStepSchema> = (step, query) => {
  const directResults = searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      storage: ['storage'],
      dialog: ['defaultAnswer.dialog'],
      text: [
        'question',
        'condition',
        'questionFirst',
        'otherAnswer',
        'otherAnswerQuestion',
        'questionMale',
        'inputHint',
        'retryPrompt',
        'skipAnswer',
        'skipFirstAnswer',
        'defaultAnswer.condition'
      ]
    })
  )

  const answerResults = step.answers?.flatMap(answer => searchInAnswer(answer, query)) ?? []

  return [...directResults, ...answerResults]
}

export function searchInAnswer(
  answer: QuestionAnswerSchema | PromptAnswerSchema,
  query: string
): FoundOccurrence<'partial'>[] {
  return searchMutableObject(
    answer,
    query,
    { type: 'answer', id: answer.id! },
    createConfigs({
      id: ['id'],
      dialog: ['dialog'],
      storage: ['storages.%key%.storage'],
      text: [
        'synonyms',
        'answer',
        'title',
        'condition',
        'subtitle',
        'text',
        'storages.%key%.value',
        'storages.%key%.storage'
      ]
    })
  )
}
